// extracted by mini-css-extract-plugin
export var bubble = "_11-0";
export var container = "_11-3";
export var contrastBorder = "_11-4";
export var greyOut = "_11-2";
export var initialsWrapper = "_11-1";
export var large = "_11-9";
export var medium = "_11-8";
export var mediumSmall = "_11-7";
export var mediumSmallMedium = "_11-c";
export var micro = "_11-5";
export var small = "_11-6";
export var tiny = "_11-b";
export var xTiny = "_11-a";